export default class TrackerAffilae {

    constructor() {
        this.enabled = false;
    }

    load() {
        if(!this.enabled) {
            this.enabled = true;

            // TAG
            window._ae = {
                'pid': '5c483d4d9dc7a6795835d4cc',
                'advertiserFirst': 21600, // 15 days in mins
                'allowSiteUnder': false,
                'allowIframing': false,
                'host': 'https://lb.affilae.com'
            };
            (function () {
                var element = document.createElement('script');
                element.type = 'text/javascript';
                element.async = true;
                element.src = '//static.affilae.com/ae-v3.5.js';
                var scr = document.getElementsByTagName('script')[0];
                scr.parentNode.insertBefore(element, scr);
            })();
        }
    }

    sendOnPageLoad() {
        if(!this.enabled) return;
        
        // TAG DE CONVERSION
        if(window.trackerVar.montant_total_ht > 0 && window.trackerVar.listing_google.length > 0) {
            let key = "5c483fe79dc7a6795835e1f9-5c483d4d9dc7a6795835d4cc";
            if(window.trackerVar.nb_cmds > 1) key = "5c48401d9dc7a6795835e320-5c483d4d9dc7a6795835d4cc";

            window.aeEvent = {};
            aeEvent.key = key;
            aeEvent.Conversion = {};
            aeEvent.Conversion.id = window.trackerVar.id_panier;
            aeEvent.Conversion.amount = window.trackerVar.montant_total_ht;
            aeEvent.Conversion.payment = 'online';

            ('AeTracker' in window)
                ? AeTracker.sendConversion(aeEvent)
                : (window.AE = window.AE || []).push(aeEvent);
        }
    }

}
